// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `* {
  box-sizing: border-box;
}
body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  color: #20332e;
  background: #f6f8f5;
}
a {
  color: #23664f;
  text-decoration: none;
}
a:hover {
  text-decoration: underline;
}
button,
input,
select,
textarea {
  font: inherit;
}
button,
.button {
  cursor: pointer;
  border: 1px solid #cedad3;
  border-radius: 8px;
  padding: 10px 16px;
  background: white;
  color: #20332e;
}
button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
button:hover:not(:disabled) {
  background: #edf3ee;
}
:focus-visible {
  outline: 3px solid #82bda0;
  outline-offset: 3px;
}
label {
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
}
input,
select {
  padding: 11px 12px;
  border: 1px solid #cedad3;
  border-radius: 7px;
  background: white;
  color: #20332e;
  min-width: 0;
}
h1 {
  font-size: clamp(28px, 4vw, 42px);
  letter-spacing: -1.4px;
  line-height: 1.15;
  font-weight: 650;
}
h2 {
  font-size: 19px;
  font-weight: 600;
}
pre {
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  background: #f1f4f1;
  padding: 18px;
  border-radius: 8px;
  font-size: 13px;
  line-height: 1.65;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;AACA;EACE,SAAS;EACT,sEAAsE;EACtE,cAAc;EACd,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,qBAAqB;AACvB;AACA;EACE,0BAA0B;AAC5B;AACA;;;;EAIE,aAAa;AACf;AACA;;EAEE,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,YAAY;AACd;AACA;EACE,iCAAiC;EACjC,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,eAAe;EACf,iBAAiB;AACnB","sourcesContent":["* {\n  box-sizing: border-box;\n}\nbody {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  color: #20332e;\n  background: #f6f8f5;\n}\na {\n  color: #23664f;\n  text-decoration: none;\n}\na:hover {\n  text-decoration: underline;\n}\nbutton,\ninput,\nselect,\ntextarea {\n  font: inherit;\n}\nbutton,\n.button {\n  cursor: pointer;\n  border: 1px solid #cedad3;\n  border-radius: 8px;\n  padding: 10px 16px;\n  background: white;\n  color: #20332e;\n}\nbutton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\nbutton:hover:not(:disabled) {\n  background: #edf3ee;\n}\n:focus-visible {\n  outline: 3px solid #82bda0;\n  outline-offset: 3px;\n}\nlabel {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  font-size: 14px;\n  font-weight: 600;\n}\ninput,\nselect {\n  padding: 11px 12px;\n  border: 1px solid #cedad3;\n  border-radius: 7px;\n  background: white;\n  color: #20332e;\n  min-width: 0;\n}\nh1 {\n  font-size: clamp(28px, 4vw, 42px);\n  letter-spacing: -1.4px;\n  line-height: 1.15;\n  font-weight: 650;\n}\nh2 {\n  font-size: 19px;\n  font-weight: 600;\n}\npre {\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n  background: #f1f4f1;\n  padding: 18px;\n  border-radius: 8px;\n  font-size: 13px;\n  line-height: 1.65;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
